exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cellNumberType[data-v-940038b4] {\n    text-align: right;\n}\n", ""]);

// exports
